import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LabelBox } from '../Box/LabelBox';
import { TextInputBox } from '../Box/TextInputBox';
import { axiosInstance } from '../../functions/axios';

import styled from 'styled-components';

import { Box, Button, Field, Icon, FieldLabel, Grid, TextInput, Typography, InlineNotification, Text } from '@blueprint/ui';

const StyledDiv = styled.div`
    padding-top: 100px;
    padding-right: 5vw;
    padding-left: 5vw;
    padding-bottom: 5em;
    /* max-width: 1280px; */
`;

const MobileConfirmation = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const PAYMENT_LIST = process.env.REACT_APP_PAYMENT_LIST;
    const globalState = useSelector((state) => state);
    const footerHeight = globalState.beneDetails.footerHeight;
    const FETCH_USER_DETAILS_URL = process.env.REACT_APP_FETCH_USER_DETAILS_URL;
    const VALIDATE_MOBILE_URL = process.env.REACT_APP_VALIDATE_MOBILE_URL;

    //STATE VARIABLES
    const [userDetails, setUserDetails] = useState({
        email: '',
        name: '',
        isd: '',
        number: '',
    });
    const [confirmMobile, setConfirmMobile] = useState('');
    const [showMobileError, setShowMobileError] = useState(false);
    const [mobileError, setMobileError] = useState('');
    const [mobileVerified, setMobileVerified] = useState(false);

    useEffect(() => {
        if (!globalState.beneDetails.details.isLogged) {
            history.push('/');
        }
    }, [globalState, history]);

    // FETCH USER DETAILS
    useEffect(() => {
        const callUserDetails = async () => {
            const response = await axiosInstance.post(
                FETCH_USER_DETAILS_URL,
                JSON.stringify({
                    emailId: globalState.beneDetails.details.emailId,
                })
            );
            if (response) {
                const responseJson = response.data;
                console.log('Logging FETCH_USER_DETAILS API Response', responseJson);

                if (response.status !== 200) {
                } else {
                    setUserDetails({
                        name: response.data.name,
                        isd: response.data.mobileCountryCode,
                        number: response.data.maskedMobileNo,
                    });
                }
            }
        };

        if (globalState.beneDetails.details.emailId !== '') {
            callUserDetails();
        }
    }, [FETCH_USER_DETAILS_URL]);

    const validateMobileError = () => {
        if (confirmMobile === '' || confirmMobile === null) {
            setShowMobileError(true);
            setMobileError(t('mobileConfirmationPage.error'));
            return false;
        } else {
            setShowMobileError(false);
            return true;
        }
    };

    const validateMobile = () => {
        if (confirmMobile !== null && confirmMobile !== '') {
            const callValidateMobile = async () => {
                try {
                    const response = await axiosInstance.post(
                        VALIDATE_MOBILE_URL,
                        JSON.stringify({
                            confirmMobileCntryCd: userDetails.isd,
                            confirmMobileNo: confirmMobile,
                            emailId: globalState.beneDetails.details.emailId,
                        })
                    );

                    if (response.status === 200) {
                        setMobileVerified(true);
                    }
                } catch (error) {
                    if (error && error.response && error.response.status === 400) {
                        setMobileError(t('mobileConfirmationPage.user_error_001'));
                        setShowMobileError(true);
                    }
                }
            };
            callValidateMobile();
        } else {
            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                    console.log('Logging first element having class hasError', elementsWithError[0]);
                    elementsWithError[0].focus();
                }
            }, 200);
        }
    };

    return (
        <StyledDiv style={{ paddingBottom: `${footerHeight + 20}px` }}>
            <Grid container>
                <Box marginBottom={['25px', '25px', '25px', '0px']}>
                    <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                        <Typography variant='h1' id='mc-sectionTitle' className='page-title' tabIndex='-1'>
                            {t('mobileConfirmationPage.section_title')}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
            <Grid container>
                <Field name='mc-textBox-name'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('mobileConfirmationPage.name')}</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInputBox>
                            <TextInput value={userDetails.name} disabled />
                        </TextInputBox>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Field name='mc-textBox-email'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('mobileConfirmationPage.email')}</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextInputBox>
                            <TextInput fieldType='uneditable' value={globalState.beneDetails.details.emailId} disabled />
                        </TextInputBox>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <Box marginTop={['10px', '10px', '10px', '24px']}>
                        <Typography variant='body1'>{t('mobileConfirmationPage.confirm_sub_label')}</Typography>
                    </Box>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={2}>
                    <LabelBox>
                        <FieldLabel variant='body1'>{t('mobileConfirmationPage.mobile_number')}</FieldLabel>
                    </LabelBox>
                </Grid>
                <Grid item xs={2} sm={1} md={1} lg={1} xl={1} style={{ paddingRight: '8px' }}>
                    <TextInputBox>
                        <TextInput placeholder='Country Code' value='****' disabled />
                    </TextInputBox>
                </Grid>
                <Grid item xs={9} sm={4} md={2} lg={3} xl={2}>
                    <TextInputBox>
                        <TextInput placeholder='Number' value={userDetails.number} disabled />
                    </TextInputBox>
                </Grid>

                {mobileVerified ? (
                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Box marginTop={['15px', '15px', '15px', '25px']} marginLeft={['5px', '5px', '5px', '10px']}>
                            <Icon name='StatusConfirmationLight' aria-label='statuscl' />
                        </Box>
                    </Grid>
                ) : null}
            </Grid>

            {mobileVerified ? null : (
                <>
                    <Grid container>
                        <Field name='mc-textbox-mobile-confirm'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1'>{t('mobileConfirmationPage.confirm_mobile_number')} *</FieldLabel>
                                </LabelBox>
                            </Grid>
                            <Grid item xs={2} sm={1} md={1} lg={1} xl={1} style={{ paddingRight: '8px' }}>
                                <TextInputBox>
                                    <TextInput value={userDetails.isd} id='mc-textbox-isd-confirm' disabled />
                                </TextInputBox>
                            </Grid>
                            <Grid item xs={9} sm={4} md={2} lg={3} xl={3}>
                                <TextInputBox>
                                    <TextInput
                                        className={showMobileError ? 'hasError' : ''}
                                        placeholder={t('mobileConfirmationPage.placeholder')}
                                        value={confirmMobile}
                                        onChange={(event) => {
                                            setConfirmMobile(event.value);
                                        }}
                                        onBlur={() => {
                                            setTimeout(validateMobileError, 500);
                                        }}
                                        invalid={showMobileError}
                                        aria-describedby='mc-inline-error-mobile-confirm'
                                    />
                                </TextInputBox>
                            </Grid>
                        </Field>

                        {showMobileError ? (
                            <Grid container>
                                <Grid item xs={6} sm={2}></Grid>
                                <Grid item xs={12} sm={4}>
                                    <InlineNotification id='mc-inline-error-mobile-confirm' title='' variant='error' fontVariant='body2'>
                                        {mobileError}
                                    </InlineNotification>
                                </Grid>
                            </Grid>
                        ) : null}
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={2}></Grid>
                        <Grid item md={3}>
                            <Box marginBottom={3} marginTop={['5px', '5px', '5px', '15px']}>
                                <Button
                                    id='mc-button-validate-mobile'
                                    style={{
                                        width: '100%',
                                        justifyContent: 'center',
                                    }}
                                    variant='light.tertiary'
                                    onClick={() => {
                                        validateMobile();
                                    }}
                                >
                                    {t('mobileConfirmationPage.button')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </>
            )}

            <Grid container>
                <Grid item xs={12} sm={6}>
                    <Box
                        display='flex'
                        flexDirection='row-reverse'
                        justifyContent='space-between'
                        width='100%'
                        maxWidth='650px'
                        paddingTop='1em'
                        mt={4}
                        borderTop='1px solid #333'
                    >
                        <Button
                            id='mc-button-continue'
                            variant='light.primary'
                            disabled={!mobileVerified}
                            onClick={() => {
                                history.push(PAYMENT_LIST);
                            }}
                        >
                            {t('mobileConfirmationPage.continue')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </StyledDiv>
    );
};

export default MobileConfirmation;
